export const initScrollDetection = () => {
  let lastY = window.scrollY
  let ticking = false
  let scrollDownTimer = null

  const threshold = () => {
    const style = getComputedStyle(document.documentElement)
    const remToPx = Number.parseFloat(style.fontSize)
    const h =
      Number.parseFloat(style.getPropertyValue("--header-height")) * remToPx
    const p = Number.parseFloat(style.getPropertyValue("--header-padding")) || 0
    return h + 2 * p
  }

  const update = () => {
    const y = window.scrollY
    const cl = document.body.classList
    const h = threshold()

    cl.toggle("is-scrolled", y > 0)

    if (y > lastY && y > h) {
      // scrolling down past header height — delay by 1s
      if (!scrollDownTimer) {
        scrollDownTimer = setTimeout(() => {
          cl.add("scroll-down")
          cl.remove("scroll-up")
          scrollDownTimer = null
        }, 50)
      }
    } else if (y < lastY || y <= h) {
      // scrolling up or back above header height — immediate
      clearTimeout(scrollDownTimer)
      scrollDownTimer = null
      cl.remove("scroll-down")
      cl.toggle("scroll-up", y <= h)
    }

    lastY = y
    ticking = false
  }

  window.addEventListener(
    "scroll",
    () => {
      if (!ticking) {
        requestAnimationFrame(update)
        ticking = true
      }
    },
    { passive: true },
  )
}
